import {searchAPI} from '../search/rtkSearchApi'
import {IdType} from '../util/models/IdType'
import {SimpleItem} from './model/SimpleItem'
import {FileResource} from './model/FileResource'

export const itemApi = searchAPI.enhanceEndpoints({})
    .injectEndpoints({
        endpoints: (builder) => ({
            getItemDetails: builder.query<SimpleItem, { itemId?: IdType, guildId?: IdType }>({
                query: ({itemId, guildId}) => ({
                    url: !guildId ? `items/${itemId}` : `guilds/${guildId}/items/${itemId}`,
                    method: 'GET'
                }),
                keepUnusedDataFor: 5,
                transformErrorResponse: () => 'An error occurred while retrieving item details.'
            }),
            getArtifactFile: builder.query<FileResource, { itemId?: IdType, guildId?: IdType, documentId?: IdType }>({
                query: ({itemId, guildId, documentId}) => ({
                    url: !guildId ? `items/${itemId}/artifact/${documentId}` : `guilds/${guildId}/items/${itemId}/artifact/${documentId}`,
                    method: 'GET'
                }),
                keepUnusedDataFor: 5,
                transformErrorResponse: () => 'An error occurred while retrieving artifact file.'
            })
        })
    })

export const {useGetItemDetailsQuery, useLazyGetArtifactFileQuery} = itemApi
